import { render, staticRenderFns } from "./FiltroModel.vue?vue&type=template&id=60890f3e&"
import script from "./FiltroModel.vue?vue&type=script&lang=js&"
export * from "./FiltroModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports